import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { LeftNavBar } from "./components/LeftNavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Preloader } from "./components/Preloader";
import ChatBot from "./components/ChatBot";
import { CareerTimeline } from "./components/CareerTimeline";
import { SkillsShowcase } from "./components/SkillsShowcase";
import RevealSection from "./components/RevealSection";
import logo from "./assets/img/logo.png";
import { Analytics } from "@vercel/analytics/react";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="App">
      {loading ? (
        <Preloader />
      ) : (
        <>
          <div className="noise-overlay"></div>
          <div className="aurora-orb aurora-orb--1"></div>
          <div className="aurora-orb aurora-orb--2"></div>
          <div className="aurora-orb aurora-orb--3"></div>
          <LeftNavBar />
          {/* Fixed top-right logo */}
          <a href="#home" className="top-right-logo" onClick={e => { e.preventDefault(); document.getElementById('home')?.scrollIntoView({behavior:'smooth'}); }}>
            <img src={logo} alt="Logo" />
          </a>
          <div className="hero-sticky">
            <Banner />
          </div>
          <div className="main-content-reveal">
            <Skills />
            <SkillsShowcase />
            <CareerTimeline />
            <Projects />
            <Contact />
          </div>
          <div className="footer-reveal-wrapper">
            <Footer />
            <RevealSection />
          </div>
          <ChatBot />
          <Analytics />
        </>
      )}
    </div>
  );
}

export default App;
